import { PermissionMap } from "../store/slices/authSlice";
import { hasPermission } from "./permissionUtils";
import { ROUTE_CONFIG, RouteAccess } from "./utils";

type GroupedRoutes = Record<string, RouteAccess[]>;

export const generateMenuByAccess = (
  permissions: PermissionMap,
  userRole: 'SuperAdmin' | 'Admin' | 'Client' | string,
): GroupedRoutes => {
  const grouped: GroupedRoutes = {};

  ROUTE_CONFIG.forEach((route) => {
    const hasRoutePermission =
      !route.requiredPermission ||
      hasPermission(permissions, route.requiredPermission) || userRole === "SuperAdmin";

    if (hasRoutePermission && route.showInMenu !== false) {
      const group = route.navGroup || "Other";

      if (!grouped[group]) {
        grouped[group] = [];
      }

      grouped[group].push(route);
    }
  });

  return grouped;
};
